<template>
  <v-col cols="12" class="d-flex justify-space-between">
    <div class="d-flex commentsAction">
      <span class="mr-md-10 mr-2">
        <ButtonLike
          type="comment"
          :entityId="item.id"
          :isLiked="item.isLiked"
          :count="item.totalLike"
          :parent="parent"
          oneway
          @onLike="$emit('onLike', arguments[0])"
        />
      </span>
      <span v-if="!noReply">
        <ButtonReply @click="$emit('replyComment', item.id)" />
      </span>
    </div>
    <div>
      <v-menu bottom left v-model="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small v-bind="attrs" v-on="on">
            <v-icon class="fal fa-ellipsis-stroke" size="20"></v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-if="item.canUpdate" @click="$emit('editComment', item)">
            <v-list-item-title>
              <v-icon class="fas fa-pen pr-2" size="15"></v-icon>
              {{ $gettext("Edit") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="item.canDelete" @click="deleteComment(item)">
            <v-list-item-title>
              <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
              {{ $gettext("Delete") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item v-if="!item.canUpdate" @click="reportComment(item.id)">
            <v-list-item-title>
              <v-icon class="fal fa-circle-exclamation pr-2" size="15"></v-icon>
              {{ $gettext("Report") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
  </v-col>
</template>
<script>
import ButtonLike from "@/components/Buttons/ButtonLike";
import ButtonReply from "@/components/Buttons/ButtonReply";
import ButtonReport from "@/components/Buttons/ButtonReport";

export default {
  props: {
    item: {},
    entityName: {},
    parent: {},
    noReply: { type: Boolean, default: false }
  },
  components: {
    ButtonLike,
    ButtonReply,
    ButtonReport
  },
  data() {
    return {
      menu: null,
    };
  },
  methods: {
    async deleteComment(comment) {
      const result = await this.$store.state.toggle.dialogConfirm.open(
        this.$gettext("Confirm your action"),
        this.$gettext('Do you want to delete this comment ?'),
        { color: "warning" }
      );
      if (!result) return
      await this.$store.dispatch("removeComment", comment.id);
      this.menu = false;
      this.$emit("removeComment", comment);
    },
    reportComment(id) {
      this.$store.dispatch("setReport", {
        entityId: id,
        entityName: "comment",
      });
    },
  },
};
</script>